

import React, { Component } from 'react';

class NewUpdateModal extends Component {

    render() {
        return (
            <div>
                <div className="modal fade bd-example-modal-lg" data-backdrop="static" data-keyboard="false"  role="dialog"  id="newUpdateModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content" style={{boxShadow: "1px 1px 10px rgba(1,1,1,0.3)"}}>

                            <div className="modal-header">
                                <button type="button" className="close" aria-label="Close">
                                    <span  aria-hidden="true" data-dismiss = "modal">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                                <div className='text-center'>
                                                    <h4>Hay una nueva version. <br/>Presione Ctrl + Shift + R para actualizar y continuar.</h4>
                                                </div>
                                                <img src={require('../images/controlShiftR.jpg')} style={{maxWidth: "736px"}} alt="Logo" />
                                                
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewUpdateModal;